module.exports = __webpack_public_path__ + "media/images/icons/icn_010-55bd7d872dbab6c4fd8a7584691179af.svg";